/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPagePropertyItemMultipleSelectionSubtextErrorMessage } from './formPagePropertyItemMultipleSelectionSubtextErrorMessage';


/**
 * 選択した選択肢番号に対応する補助テキスト
 */
export interface FormPagePropertyItemMultipleSelectionPropertyItemSubtext { 
    type: FormPagePropertyItemMultipleSelectionPropertyItemSubtext.TypeEnum;
    /**
     * 補助テキストの入力上限. 4000文字固定
     */
    maxLength: number;
    errorMessage: FormPagePropertyItemMultipleSelectionSubtextErrorMessage;
}
export namespace FormPagePropertyItemMultipleSelectionPropertyItemSubtext {
    export type TypeEnum = 'string';
    export const TypeEnum = {
        String: 'string' as TypeEnum
    };
}



